
import PopupAnimation from '../../components/animations/PopupAnimation';
import { FaChevronRight, FaChevronLeft } from "react-icons/fa";

import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
dayjs.extend(localizedFormat);

function ImageModal({ clickedImg, imagePopupRef, onClose, uid, mediaImageList, setClickedImg }) {

  const selectPrevImg = () => {
    const ind = mediaImageList.findIndex((item) => (clickedImg?.id === item.id))

    if (ind !== 0) {
      setClickedImg(mediaImageList[ind - 1])
    }
  }

  const selectNextImg = () => {

    const ind = mediaImageList.findIndex((item) => (clickedImg?.id === item.id))

    if (ind !== mediaImageList.length - 1) {
      setClickedImg(mediaImageList[ind + 1])
    }
  }

  function extractContent(s) {
    var span = document.createElement('span');
    span.innerHTML = s;
    return span.textContent || span.innerText;
  };


  return (
    <PopupAnimation showDiv={clickedImg ? true : false} >
      <div className={`relative flex w-[85vw] h-[91vh] flex-col rounded-xl ${clickedImg?.createdById === uid ? "bg-lightPrimary text-gray-800 border-headPrimary" : "bg-lightSecondary text-gray-800 border-headSecondary"} shadow-lg outline-none dark:bg-navy-800 focus:outline-none`}>
        <div ref={imagePopupRef} className="h-fit overflow-auto">
          <div className="items-center rounded-t p-4 md:p-5">
            <div className="absolute top-3 left-3 text-xs font-normal flex flex-col text-gray-600">
              <div className="font-medium">{clickedImg?.displayName}</div>
              <div className="font-normal">{dayjs(clickedImg?.createdAt).format("lll")}</div>
            </div>

            <h3 className="text-center text-gray-800 h-[33px] text-2xl font-semibold dark:text-white px-3 truncate">
              {extractContent(clickedImg ? clickedImg.message : "")}
            </h3>
            <button
              onClick={onClose}
              type="button"
              className="bg-transparent absolute absolute top-0 right-0 m-5 inline-flex h-8 w-8 items-center justify-center rounded-lg text-sm text-gray-400 ms-auto hover:bg-gray-200 hover:text-headPrimary dark:hover:bg-gray-600 dark:hover:text-white"
              data-modal-hide="static-modal"
            >
              <svg
                className="h-3 w-3"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 14 14"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                />
              </svg>
              <span className="sr-only">Close modal</span>
            </button>
          </div>

          <div className="relative mt-3 w-full min-h-[465px] h-[calc(100%-270px)] flex justify-center">

            <div onClick={() => {
              selectPrevImg()
            }}
              className="flex items-center justify-center pr-2 py-4 cursor-pointer absolute left-0 top-[calc(100%-280px)]  bg-white shadow-md hover:shadow-lg rounded-r-full border-t border-b border-r">
              <FaChevronLeft className='w-9 h-9' />
            </div>

            <div className="rounded-lg h-full border border-gray-500 shadow-xl bg-white">
              <img
                className="rounded-lg h-full"
                src={clickedImg?.url} alt=""
              />
            </div>

            <div
              onClick={() => {
                selectNextImg()
              }}
              className="flex items-center justify-center pl-2 py-4 cursor-pointer absolute right-0 top-[calc(100%-280px)]  bg-white shadow-md hover:shadow-lg rounded-l-full border-t border-b border-l">
              <FaChevronRight className='w-9 h-9' />
            </div>
          </div>

          <div className={`mt-6 p-2 w-full h-[105px]  overflow-x-auto flex items-center text-sm font-medium text-gray-500 bg-white border-t border-b border-gray-200 shadow-sm dark:text-gray-400 sm:text-base dark:bg-gray-800 dark:border-gray-700`}>
            <div className="w-fit flex items-center justify-start space-x-4">
              {mediaImageList.map((item, i) => (
                <div key={item.id}
                  onClick={() => {
                    setClickedImg(item)
                  }}
                  className={`h-[81px] w-[120px]  flex flex-col py-0.5 
                      ${clickedImg?.id !== item.id ? "bg-gray-50" : clickedImg?.createdById === uid ? "bg-lightPrimary text-gray-800 border-headPrimary" : "bg-lightSecondary text-gray-800 border-headSecondary"} border rounded-md shadow-sm px-1 `}>
                  <div className="w-full flex items-center justify-between mb-0.5">
                    <p className="text-[9px] truncate ">
                      {item.displayName}
                    </p>
                  </div>

                  <img
                    onClick={() => { }}
                    className="cursor-pointer border object-cover w-[calc(100%-1px)] h-[calc(100%-18px)] z-1"
                    src={item.url} alt="" />
                </div>
              ))}

            </div>
          </div>

        </div>
      </div>
    </PopupAnimation>
  )
}

export default ImageModal